import { useEffect, useState } from "react";
import CountryController from "../controllers/CountryController";
import Country from "../models/Country";
import { usePlan } from "../_providers/PlanProvider";

export const CreatePlanPage = () => {
    const [plan_name, setPlanName] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [countries, setCountries] = useState<Country[]>([]);

    const planContext = usePlan();

    useEffect(() => {
        CountryController.getCountries().then((countries) => {
            setCountries(countries);
            setLoading(false);
        });
    }, []);

    if(loading) return <p>Loading...</p>;
    return (
        <div>
            <h1>Create Plan</h1>
            <input
                type="text"
                placeholder="Plan Name"
                value={plan_name}
                onChange={(e) => setPlanName(e.target.value)}
            />
            <select onChange={(e) => setCountry(e.target.value)}>
                <option value="">Select a country</option>
                {countries.map((country) => (
                    <option key={country.name} value={country.name}>{country.name}</option>
                ))}
            </select>
            <button onClick={() => planContext.createPlan(plan_name, country)}>Create Plan</button>
        </div>
    )
}